import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { RolePermissionService } from 'src/app/core/services/role-permission.service';
import { CookieService } from 'ngx-cookie-service';
import { DashboardService } from '../../core/services/dashboard.service';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SuperadminHomeComponent } from '../../components/superadmin-home/superadmin-home.component';
import { localStorageConstants, localStorageVariables, versioning } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LookupService } from 'src/app/core/services/lookup.service';
import { InteractorService } from 'src/app/core/services/interactor.service';
import { EnvService } from 'src/app/core/services/env.service';
import { CustomizationService } from 'src/app/core/services/customization.service';
import { QuestionnaireInteractionService } from 'src/app/core/services/questionnaire-interaction.service';
import { sidebarContent } from 'src/app/core/sidebarContents/sidebar-content';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  superadminDialog: SuperadminHomeComponent;
  permissions: any;
  public error: boolean;
  public version;
  public message: string;
  public tenant: string;
  public showAgency: boolean;
  brandingDetails = JSON.parse(localStorage.getItem('branding'));
  boldFont = this.brandingDetails?.branding?.Font?.BoldFont;
  headerBackgroundColor: any;
  sideBarBackgroundColor: any;
  sideBarActiveBackgroundColor: any;
  sideBarFontColor: any;
  sideBarActiveFontColor: any;
  sideBarHoverBackgroundColor: any;
  hoveredMenu: string;
  public sidebarContent:any[] = sidebarContent;

  menuPermissions: any = {
    sideBarMenu: false,
    peopleMenu: false,
    helpersMenu: false,
    questionnaireMenu: false,
    insightsMenu: false,
    settingsMenu: false,
    dashboardMenu: false,
    switchAgency: false
  };
  brandingSetSubscribe: any;
  isChanged: boolean = false;
  @Input() set confirmCastValue(data) {
      if (data && data?.value) {
        if(data.triggerFrom=='switchAgency'){
          this.openSuperAdminModal();
        }
      }
    }
  constructor(private rolePermissionService: RolePermissionService,
    private cookieService: CookieService,
    private localStorageService: LocalStorageService,
    private dashboardService: DashboardService,
    private router: Router,
    private modalService: BsModalService,
    private translatorService: TranslateService,
    private interactorService: InteractorService,
    private lookupService: LookupService,
    private envService: EnvService,
    private customizationService: CustomizationService,
    public qiService: QuestionnaireInteractionService
  ) {
    this.translatorService.setDefaultLang('en');
    this.translatorService.use(localStorage.getItem('lang') || 'en');
  }
  isModalOpen = false;

  ngOnInit(): void {
    window.addEventListener('resize', this.handleWindowResize);
    this.interactorService.brandingDetailsCast.subscribe(data => {
      if (data) {
        this.brandingDetails = data;
        document.documentElement.style.setProperty('--boldFont', this.brandingDetails?.branding?.Font?.BoldFont);
      }
      this.setBackgroundColors();
    });
    document.documentElement.style.setProperty('--boldFont', this.brandingDetails?.branding?.Font?.BoldFont);
    this.getPermissions();
    this.getBrandingDetails();
    this.showAgency = false;
    this.version = versioning[this.envService?.env];
    // tslint:disable-next-line: triple-equals
    if (this.localStorageService.getDataFromLocalStorage(localStorageVariables.role) == 'Super Admin') {
      this.showAgency = true;
    }
    this.qiService.valueChangesCast.subscribe((val) => {
      this.isChanged = val;
    });
  }

  getBrandingDetails() {
    this.brandingSetSubscribe = this.customizationService?.brandingValueCast?.subscribe((val: any) => {
      if (val) {
        this.brandingDetails = val;
        this.interactorService.changeBrandingDetails(this.brandingDetails);
        document.documentElement.style.setProperty('--boldFont', this.brandingDetails?.branding?.Font?.BoldFont);
        this.setBackgroundColors();
      }
    })
  }

  handleWindowResize = () => {
    if (window.innerWidth > 1024) {
      this.resetSidebarStyles();
    }
  }

  private resetSidebarStyles() {
    const menuOverlay = document.getElementById('overlay');
    const btnHamburger = document.getElementById('hamburgerBtn');
    const navSidebar = document.getElementById('sidebar');

    if (btnHamburger) btnHamburger.style.display = '';
    if (navSidebar) {
      navSidebar.style.width = navSidebar.style.transform = navSidebar.style.transition = '';
    }
    if (menuOverlay) {
      menuOverlay.style.display = menuOverlay.style.backgroundColor = '';
    }
  }

  hamburgerOpen = () => {
    if (window.innerWidth <= 1024) {
      const menuOverlay: any = document.getElementById('overlay');
      const btnHamburger: any = document.getElementById('hamburgerBtn');
      const navSidebar: any = document.getElementById('sidebar');
      btnHamburger.style.display = 'none';
      navSidebar.style.width = '200px';
      navSidebar.style.transform = 'translate3d(0vw, 0, 0)';
      navSidebar.style.transition = '0.4s';
      menuOverlay.style.display = 'block';
      menuOverlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
    }
  }

  closeSidebar = (event) => {
    if (window.innerWidth <= 1024) {
      const menuOverlay: any = document.getElementById('overlay');
      const btnHamburger: any = document.getElementById('hamburgerBtn');
      const navSidebar: any = document.getElementById('sidebar');
      btnHamburger.style.display = 'block';
      navSidebar.style.width = '0px';
      navSidebar.style.transform = 'translate3d(-100vw, 0, 0)';
      navSidebar.style.transition = '0.9s';
      menuOverlay.style.display = 'none';
      menuOverlay.style.backgroundColor = 'rgba(0,0,0,0)';
    }
    const val = event.target.innerHTML;
    this.resetHelperIndex()
    const helperIndex = this.dashboardService.getCurrentHelperIndex();
    if (helperIndex !== undefined) {
      if (val === 'Dashboard') {
        this.dashboardService.setHelperIndex(undefined);
        this.router.navigateByUrl('/people', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard']);
        });
      }
      if (val === 'People') {
        this.dashboardService.setHelperIndex(undefined);
        this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/people']);
        });
      }
    }
  }

  settingsClick(){
    window.dispatchEvent(new CustomEvent('settingsMenuClicked'));
  }
  notImplemented() {
    alert('Not Implemented.');
  }
  getPermissions() {
    const tenantAbbreviation = this.localStorageService.getDataFromLocalStorage(localStorageVariables.tenantAbbreviation);
    this.tenant = tenantAbbreviation;
    this.rolePermissionService.subscribePermission.subscribe((permission) => {
      if (permission) {
        this.permissions = permission;
        this.menuPermissions.sideBarMenu = this.rolePermissionService.isAuthorized('SidebarMenu', 'View');
        this.menuPermissions.peopleMenu = this.rolePermissionService.isAuthorized('People', 'View');
        this.menuPermissions.helpersMenu = this.rolePermissionService.isAuthorized('SideBar_Helper', 'View');
        this.menuPermissions.questionnaireMenu = this.rolePermissionService.isAuthorized('Questionnaires', 'View');
        this.menuPermissions.insightsMenu = this.rolePermissionService.isAuthorized('Insights', 'View');
        this.menuPermissions.settingsMenu = this.rolePermissionService.isAuthorized('Settings', 'View');
        this.menuPermissions.dashboardMenu = this.rolePermissionService.isAuthorized('Dashboard', 'View');
        this.menuPermissions.switchAgency = this.rolePermissionService.isAuthorized('Switch Agency', 'View');
      }
    });
  }

  openSuperAdminModal() {
    if (!this.isChanged) {
      this.modalRef = this.modalService.show(SuperadminHomeComponent, {
        backdrop: 'static', keyboard: false
      });
      this.isModalOpen = true;
      localStorage.setItem('isFromAdvancedSearch', 'false');
      localStorage.setItem('isAdvanceSearchBE', 'false');
    } else {
      const obj = {
        confirm: true,
        route: null,
        triggerFrom: 'switchAgency'
      };
      this.qiService.setConfirmation(obj);
    }
  }

  hide() {
    this.modalRef.hide();
    this.isModalOpen = false;
  }

  setBackgroundColors() {
    this.headerBackgroundColor = this.brandingDetails?.branding?.BackgroundColors?.Headers;
    this.sideBarBackgroundColor = this.brandingDetails?.branding?.BackgroundColors?.SideBarBackground;
    this.sideBarActiveBackgroundColor = this.brandingDetails?.branding?.BackgroundColors?.SideBarActive;
    this.sideBarFontColor = this.brandingDetails?.branding?.BackgroundColors?.SidebarFontColor;
    this.sideBarActiveFontColor = this.brandingDetails?.branding?.BackgroundColors?.SidebarActiveFontColor;
  }

  onMouseOver(value: any) {
    this.hoveredMenu = value;
    this.sideBarHoverBackgroundColor = this.brandingDetails?.branding?.BackgroundColors?.SidebarHoverBackground;
  }

  onMouseLeave() {
    this.sideBarHoverBackgroundColor = this.brandingDetails?.branding?.BackgroundColors?.SideBarBackground;
  }

  resetHelperIndex(){
    this.dashboardService.setHelperIndex(undefined);
  }

  ngOnDestroy() {
    // Clean up window resize event listener
    window.removeEventListener('resize', this.handleWindowResize);

    if(this.brandingSetSubscribe){
      this.brandingSetSubscribe?.unsubscribe()
    }
  }
}
